import Konva from 'konva/src/Core';
import 'konva/src/Shapes/Rect';
import 'konva/src/Shapes/Text';
import PlacingComponent from 'placingEditor/placingComponent';

class DesignDescription extends PlacingComponent {
    constructor(placement, backgroundColor = '#eaeaea', textColor = '#000') {
        super();

        this.placement = placement;
        this.descriptionBg = new Konva.Rect({
            fill: backgroundColor
        });

        this.controlText = new Konva.Text({
            fill: textColor,
            padding: 2,
            alignment: 'center'
        });

        this.addKonvaNode(this.descriptionBg);
        this.addKonvaNode(this.controlText);
    }

    setText(text) {
        this.controlText.setText(text);
        this.descriptionBg.setWidth(this.controlText.getWidth());
        this.descriptionBg.setHeight(this.controlText.getHeight());
    }

    getTextWidth() {
        return this.controlText.getWidth();
    }
}

export default DesignDescription;



// WEBPACK FOOTER //
// ./src/placingEditor/design/designDescription.js